import { actions } from '../constants/SmartConversion';

export function setTrackingEvents(trackingEvents) {
  return {
    type: actions.SET_TRACKING_EVENTS,
    data: {
      trackingEvents,
    },
  };
}

export function clearTrackingEvents() {
  return {
    type: actions.SET_TRACKING_EVENTS,
    data: {
      trackingEvents: {},
    },
  };
}

export function triggerUpsell(event) {
  return {
    type: actions.TRIGGER_SMART_CONVERSION_UPSELL,
    data: {
      event,
    },
  };
}

export function launchProductOffering(product) {
  return {
    type: actions.LAUNCH_SMART_CONVERSION_PRODUCT,
    data: {
      product,
    },
  };
}
